import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

export const ErrorState = ({ title = 'Erreur de chargement', description, onRetry, className }) => (
  <div className={cn('flex flex-col items-center justify-center py-16 text-center', className)} data-testid="error-state">
    <div className="p-4 rounded-full bg-red-50 mb-4">
      <AlertTriangle className="h-8 w-8 text-red-500" />
    </div>
    <h3 className="text-lg font-semibold text-gray-700">{title}</h3>
    {description && <p className="text-sm text-gray-500 mt-1 max-w-md">{description}</p>}
    {onRetry && (
      <Button variant="outline" onClick={onRetry} className="mt-4" data-testid="error-retry-btn">
        Réessayer
      </Button>
    )}
  </div>
);

export default ErrorState;
